import { Box, Stack, TableCell, TableRow, Typography } from "@mui/material";
import { ReactNode } from "react";
import { fontWeights } from "../../themes/fontWeights";

type TableEmptyStateProps = {
  colSpan: number;
  /** Modo legado: texto livre. Ignorado se `title` for informado. */
  children?: ReactNode;
  /** Título em destaque do estado vazio. */
  title?: ReactNode;
  /** Texto de apoio abaixo do título. */
  description?: ReactNode;
  /** Call-to-action (ex: botão) exibido abaixo da descrição. */
  action?: ReactNode;
  icon?: ReactNode;
};

/** Linha padrão de "nenhum registro encontrado", usada por todas as tabelas do sistema. */
export function TableEmptyState({ colSpan, children, title, description, action, icon }: TableEmptyStateProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ py: 4, color: "text.secondary" }}>
        {title ? (
          <Stack spacing={1} alignItems="center">
            {icon ? <Box sx={{ color: "text.disabled" }}>{icon}</Box> : null}
            <Typography variant="body1" sx={{ fontWeight: fontWeights.semiBold, color: "text.primary" }}>
              {title}
            </Typography>
            {description ? (
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {description}
              </Typography>
            ) : null}
            {action ? <Box sx={{ mt: 1 }}>{action}</Box> : null}
          </Stack>
        ) : (
          children
        )}
      </TableCell>
    </TableRow>
  );
}

export default TableEmptyState;
